import type { ScheduleRepository } from '../schedule'
import { get, post } from './transport'

export function scheduleHttp(): ScheduleRepository {
  return {
    mySchedule: () => get('/api/schedule/mine'),
    setAvailability: (days) => post('/api/schedule/availability', { days }),
    answerRequest: (id, answer, reply) =>
      post(`/api/schedule/requests/${encodeURIComponent(id)}/answer`, { answer, reply: reply ?? null }),
    teamSchedule: (from) => get(`/api/schedule/team${from ? `?from=${encodeURIComponent(from)}` : ''}`),
    requestComeIn: (input) => post('/api/schedule/requests', input),
    cancelRequest: (id) => post(`/api/schedule/requests/${encodeURIComponent(id)}/cancel`, {}),
    teamToday: () => get('/api/schedule/today'),
  }
}
